import { useSyncExternalStore } from 'react';
import type { Locale } from '@ili/shared';
import { safeStorage } from './device';

export type Prefs = { language: Locale; largeText: boolean; highContrast: boolean; lowData: boolean };
const KEY = 'ili.prefs';
const store = safeStorage();
const defaults: Prefs = { language: 'en', largeText: false, highContrast: false, lowData: false };

let current: Prefs = (() => {
  try {
    return { ...defaults, ...JSON.parse(store.get(KEY) ?? '{}') };
  } catch {
    return defaults;
  }
})();
const listeners = new Set<() => void>();

function apply(p: Prefs) {
  const html = document.documentElement;
  html.classList.toggle('pref-large-text', p.largeText);
  html.classList.toggle('pref-high-contrast', p.highContrast);
  html.classList.toggle('pref-low-data', p.lowData);
  html.lang = p.language === 'fil' ? 'fil' : 'en';
}
apply(current);

export function getPrefs(): Prefs {
  return current;
}
export function setPrefs(patch: Partial<Prefs>): void {
  current = { ...current, ...patch };
  store.set(KEY, JSON.stringify(current));
  apply(current);
  listeners.forEach((l) => l());
}
export function usePrefs(): Prefs {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    () => current,
  );
}
